export default __webpack_public_path__ + "static/media/confirm.77bcba8f.svg";